import { Tooltip, styled, tooltipClasses } from '@mui/material';
import React from 'react';
import { ListGroup, ProgressBar } from 'react-bootstrap';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: '12px',
    border: '1px solid #dadde9',
  },
}));

const TestCycleProgressBar = ({ statusesData, testCasesWithNoExecutions }) => {
    const totalExecutions = Object.values(statusesData).reduce(
      (total, item) => total + item.count,
      0
    );
  const renderTooltip = () => (
    <HtmlTooltip
      id="progress-tooltip"
      title={
        <ListGroup variant="flush">
          {Object.keys(statusesData).length > 0 &&
            Object.keys(statusesData).map((status, index) => {
              const percentage =
                totalExecutions > 0
                  ? (statusesData[status].count / totalExecutions) * 100
                  : 0;
              return (
                <ListGroup.Item key={'status' + index}>
                  <span style={{ fontWeight: 500 }}>
                    {statusesData[status].name}
                  </span>{' '}
                  : {statusesData[status].count}{' '}
                  {totalExecutions > 0 && (
                    <span style={{ color: statusesData[status].color }}>
                      ({percentage.toFixed(1)}%)
                    </span>
                  )}
                </ListGroup.Item>
              );
            })}
          {testCasesWithNoExecutions > 0 && (
            <ListGroup.Item>
              TCs with no executions: {testCasesWithNoExecutions}
            </ListGroup.Item>
          )}
          <ListGroup.Item style={{ whiteSpace: 'nowrap' }}>
            <strong>Total executions: {totalExecutions}</strong>
          </ListGroup.Item>
        </ListGroup>
      }
      style={{ padding: 0 }}>
    <span style={{ display: 'inline-block', width: '100%' }}>
      <ProgressBar style={{ cursor: 'pointer' }}>
        {Object.keys(statusesData).length > 0 &&
          Object.keys(statusesData).map((status, index) => {
            const percentage =
              totalExecutions > 0
                ? (statusesData[status].count / totalExecutions) * 100
                : 0;
            return (
              <ProgressBar
                key={index}
                style={{ backgroundColor: statusesData[status].color }}
                now={percentage.toFixed(1)}
              />
            );
          })}
        </ProgressBar>
      </span>
    </HtmlTooltip>
  );

  return <>{renderTooltip()}</>;
};

export default TestCycleProgressBar;
